import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-halloween-week',
  templateUrl: './halloween-week.component.html',
  styleUrls: ['./halloween-week.component.scss']
})
export class HalloweenWeekComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/halloween-week/halloween-week.component.ts